import React, { useContext, useEffect, useState } from "react";
import "./newPartRequestTC.css";
import { Tooltip } from "@mui/material";
import { NewPartRequestPN } from "../NewPartRequestPN/NewPartRequestPN";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import { dropdownConfig } from "../../../../../services/dropdownsConfigService";
import { Dropdowns } from "../../../../../components/Dropdowns/Dropdowns";
import Skeleton from "react-loading-skeleton";
import { DialogContext } from "../../../../../contexts/DialogContext";
import { DeletePartRequestTCModal } from "./deletePartRequestTCModal/DeletePartRequestTCModal";
import { useDropdownGlobalData } from "../../../../../contexts/DropdownGlobalDataContext";
import { usePermissions } from "../../../../../hooks/usePermissions";

export const NewPartRequestTC = ({
  index,
  updateTaskCardId,
  updateFindingId,
  updatePartRequestDetailParts,
  companyId,
  initialData,
  deleteCard,
  PRNStatus,
  WPId,
}) => {
  const [taskCardDrop, setTaskCardDrop] = useState(null);
  const [FNDDrop, setFNDDrop] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const { openDialog, closeDialog } = useContext(DialogContext);
  const [TCDescription, setTCDescription] = useState(null);
  const [FNDDescription, setFNDDescription] = useState(null);
  const [PNList, setPNList] = useState([]);
  const [tcParameter, setTcParameter] = useState(null);
  const [childDropId, setChildDropId] = useState(null);
  const [parentValues, setParentValues] = useState(null);
  const [dependenciesToUpdate, setDependenciesToUpdate] = useState(null);
  const { childDropdownIdWP, parentValueWP, depToUpdateWP } =
    useDropdownGlobalData();
  const [preselectTC, setPreselectTC] = useState(null);
  const [preselectFND, setPreselectFND] = useState(null);
  const [selectedTC, setSelectedTC] = useState(null);
  const { hasPermission } = usePermissions();

  const openDeleteDialog = () => {
    if (PRNStatus == "Posted") {
      return;
    } else {
      openDialog({
        component: DeletePartRequestTCModal,
        props: {
          onClose: closeDialog,
          TCName: selectedTC?.id,
          TCDescription: TCDescription,
          deleteTC: deleteThisTc,
          isTc: initialData?.taskCardId ? true : false,
        },
      });
    }
  };

  const deleteThisTc = () => {
    deleteCard(initialData?.id);
  };
  const getDropdownConfigFND = async () => {
    let id = 68;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setFNDDrop(request.data.load);
    }
  };

  const getDropdownConfigTaskCard = async () => {
    let id = 59;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setTaskCardDrop(() => {
        return {
          ...request.data.load,
          parentValues: parentValueWP,
          //   dependencies: [
          //     ...(request?.data?.load?.dependencies || []),
          //     ...depToUpdateWP
          //   ]
        };
      });
    }
  };

  useEffect(() => {
    console.log(WPId)
    setTcParameter(() => {
      return [
        {
          columnName: "wpId",
          value: [WPId],
        },
      ];
    });
  }, [WPId]);
  const getTCSelection = (data) => {
    const description = data.description.split("-").slice(1).join("-").trim();
    setTCDescription(description);
    updateTaskCardId(index, data.id);
    setSelectedTC(data);
    // setPNList([])
  };

  const getFNDSelection = (data) => {
    updateFindingId(index, data.id);
    const description = data.description.split("-").slice(1).join("-").trim();
    setFNDDescription(description);
    // setPNList([])
  };

  const createNewPN = () => {
    if (selectedTC == null) {
    } else {
      const newPN = {
        id: Date.now(),
        companyId: companyId,
        // serializedPartId: 0,
        quantity: 0,
        uomId: 0,
        partId: 0,
        taskCardId: initialData?.taskCardId ? initialData?.taskCardId : null,
        findingId: initialData?.findingId ? initialData?.findingId : null,
      };
      setPNList([...PNList, newPN]);

      if (isOpen === false) {
        setIsOpen(true);
      }
    }
  };

  const handleDeletePn = (id) => {
    setPNList((prevState) => prevState.filter((pn) => pn.id !== id));
  };

  const updatePNQuantity = (index, newQuantity) => {
    setPNList((prevState) => {
      const updatedPNList = [...prevState];
      updatedPNList[index].quantity = parseInt(newQuantity);
      return updatedPNList;
    });
  };

  const updatePNUomId = (index, uomId) => {
    setPNList((prevState) => {
      const updatedPNList = [...prevState];
      updatedPNList[index].uomId = uomId;
      return updatedPNList;
    });
  };

  const updatePNPartId = (index, newPartId) => {
    setPNList((prevState) => {
      const updatedPNList = [...prevState];
      updatedPNList[index].partId = newPartId;
      return updatedPNList;
    });
  };

  useEffect(() => {
    getDropdownConfigTaskCard();
    getDropdownConfigFND();
    setPreselectTC(initialData?.taskCardId ? initialData?.taskCardId : null);
    setPreselectFND(initialData?.findingId ? initialData?.findingId : null);
    setPNList(
      initialData?.partRequestDetailParts
        ? initialData?.partRequestDetailParts
        : []
    );
  }, []);

  useEffect(() => {
    if (typeof updatePartRequestDetailParts === "function") {
      updatePartRequestDetailParts(index, PNList);
    }
  }, [PNList]);

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setChildDropId(dropdownId);
    setParentValues(parentValues);
    setDependenciesToUpdate(dependenciesToUpdate);
  };

  const resetDropdownsReload = () => {
    setTaskCardDrop((prevState) => ({ ...prevState, reload: false }));
  };

  return (
    <section className="NewPartRequestTC">
      <header>
        <Tooltip arrow title="Task Card">
          {initialData?.taskCardId ? (
            <i className="icon-task_icon_partRequest"></i>
          ) : (
            <i className="icon-finding_error_icon"></i>
          )}
        </Tooltip>
        <p>{initialData?.taskCardId ? "TC" : "FND"}</p>
        <div>
          <div>
            {initialData?.taskCardId && taskCardDrop ? (
              <Dropdowns
                showWarningModal={PNList.length > 0}
                warningMessagge={
                  "Are you sure you want to change this TC?, This Action will delete the PNs associated with this TC"
                }
                preventSelectionWithPreselect={false}
                preSelectValue={preselectTC}
                hideLabel={true}
                placeholder={true}
                resetDropdownsReload={resetDropdownsReload}
                updateDropdown={updateDropdown}
                onOptionSelect={getTCSelection}
                data={taskCardDrop}
                parameters={tcParameter}
              />
            ) : initialData?.findingId && FNDDrop ? (
              <Dropdowns
                showWarningModal={PNList.length > 0}
                warningMessagge={
                  "Are you sure you want to change this FND?, This Action will delete the PNs associated with this FND"
                }
                preSelectValue={preselectFND}
                hideLabel={true}
                placeholder={true}
                onOptionSelect={getFNDSelection}
                data={FNDDrop}
              />
            ) : (
              <Skeleton height={"2rem"} width={"100%"} />
            )}
          </div>
        </div>
        <p>Description</p>
        <div className="NewPartRequestTC-description">
          <Tooltip title={TCDescription} arrow>
            <p>{initialData?.taskCardId ? TCDescription : FNDDescription}</p>
          </Tooltip>
        </div>
        <p>
          PN
          <Tooltip
            title={
              initialData?.taskCardId
                ? `This TC Contains : ${PNList.length} PN(s)`
                : `This FND Contains : ${PNList.length} PN(s)`
            }
            arrow
          >
            <span tabIndex={0}>{PNList.length}</span>
          </Tooltip>
        </p>
        <p>Add PN</p>
        {hasPermission("addPN") && (
          <Tooltip title="Add New PN" arrow>
            <button onClick={createNewPN}>
              <i
                className="icon-add-aircraft"
                style={{ cursor: "pointer" }}
              ></i>
            </button>
          </Tooltip>
        )}
        {hasPermission("deleteTCF") && (
          <Tooltip
            title={
              PRNStatus == "Posted"
                ? "Cannot be deleted because the PRN status is Posted"
                : "Delete"
            }
            arrow
          >
            <button onClick={openDeleteDialog}>
              <i
                className="icon-delete-new"
                style={{
                  cursor: "pointer",
                  opacity: PRNStatus == "Posted" ? 0.5 : 1,
                }}
              ></i>
            </button>
          </Tooltip>
        )}

        <button
          style={{ fontSize: ".8rem" }}
          onClick={() => setIsOpen(!isOpen)}
        >
          <i
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
            className={"icon-arrow-down"}
          ></i>
        </button>
      </header>
      {isOpen && (
        <section>
          {PNList.length > 0 ? (
            PNList.map((pn, idx) => (
              <NewPartRequestPN
                key={pn.id}
                index={idx}
                updatePNQuantity={updatePNQuantity}
                updatePNUOMId={updatePNUomId}
                // updatePNSerializedPartId={updatePNSerializedPartId}
                updatePNPartId={updatePNPartId}
                childDropdownId={childDropId}
                parentValues={parentValues}
                dependenciesToUpdate={dependenciesToUpdate}
                initialData={pn}
                deletePnCard={handleDeletePn}
                prnStatus={PRNStatus}
                taskID={selectedTC.id}
              />
            ))
          ) : (
            <div className="part-requestTC-cont-NotFound">
              <i className="icon-info"></i>
              <p>
                There are no PN associated with this{" "}
                {initialData?.taskCardId
                  ? "TC"
                  : initialData?.findingId
                  ? "FND"
                  : ""}
              </p>
            </div>
          )}
        </section>
      )}
    </section>
  );
};
